/* eslint-disable prettier/prettier */
import { NoteModulo } from '../NoteModulos'
import { Container, ContainerGrid, Text, Titulo } from './styles'
import { useEffect, useState } from 'react'
import axios from 'axios'
import { Loader } from '../Loader'

export interface IModulo {
  cod_modulo: number
  nome: string
  id: number
  sigla: string
  mostrar_site: string
  descricao: string
}

const GridModulos = () => {
  const [modulos, setModulos] = useState<Array<IModulo>>()
  const [loading, setLoading] = useState<boolean>(true)

  async function getModulos() {
    const modulesResponse: IModulo[] = await axios
      .get('https://www.sistemacicom.com.br/solid/api_admcicom/module')
      .then(({ data }) => data)
    const order = [
      'Oficina',
      'Venda',
      'Consulta de Placas',
      'Financeiro',
      'NF-e',
      'NFC-e',
      'NFS-e',
      'SAT CF-e',
      'WhatsApp',
      'Mercado Livre',
      'Backup Nuvem',
      'Fotos Online',
      'Estoque Multi Lojas',
    ]

    const modulosOrdenados = modulesResponse.sort(
      (a, b) => order.indexOf(a.nome) - order.indexOf(b.nome)
    )
    setModulos(modulosOrdenados)
    setLoading(false)
  }

  useEffect(() => {
    getModulos()
  }, [])

  return (
    <Container>
      {loading ? (
        <Loader />
      ) : (
        <ContainerGrid>
          {modulos &&
            modulos.map((modulo) =>
              modulo.mostrar_site === 'S' ? (
                <NoteModulo
                  id={modulo.sigla}
                  codeIcon={modulo.id}
                  key={modulo.id}
                >
                  <Titulo>{modulo.nome}</Titulo>
                  <Text>{modulo.descricao}</Text>
                </NoteModulo>
              ) : (
                <></>
              )
            )}
        </ContainerGrid>
      )}
    </Container>
  )
}

export { GridModulos }
